import { RESET_SYS_PARAMETERS_STATE } from "../lib/types";


export const resetSystemParams = () => dispatch => {
    dispatch({
        type: RESET_SYS_PARAMETERS_STATE,
    });
};



// WEBPACK FOOTER //
// ./src/actions/system-parameters-actions.js